<nav class="top-bar-wrapper sticky-top">
  <div class="navbar top-header border-bottom align-items-center">
    <div class="d-flex align-items-center flex-fill">
      <app-search *ngxPermissionsOnly="['canUseSearch']" class="flex-1"></app-search>
    </div>
    <ul class="nav nav-right align-items-center gap-1">
      <li *ngxPermissionsOnly="['canSeeNotifications']" class="notification-holder">
        <app-notifications></app-notifications>
      </li>
      <li *ngxPermissionsOnly="['canSeeInquiries']" class="notification-holder">
        <app-messages-icon></app-messages-icon>
      </li>
      <li class="ml-2" *ngxPermissionsOnly="['canUseGlobalPush']">
        <a
          class="btn btn-secondary-info btn-circle"
          (click)="onPushRates()"
          i18n-matTooltip
          matTooltip="Push Rates & Availability to all connected API channels."
          matTooltipPosition="below"
        >
          <i class="fal fa-house-signal text-lg"></i>
        </a>
      </li>
      <li class="ml-2">
        <button
          *ngxPermissionsOnly="['canUseSearch']"
          (click)="onOpenInventory()"
          i18n-matTooltip
          matTooltip="Find available rentals within a date range."
          matTooltipPosition="below"
          type="button"
          class="btn btn-secondary-primary btn-circle"
        >
          <i class="cs-icon cs-icon-building"></i>
        </button>
      </li>
      <li class="ml-2" *ngxPermissionsOnly="['canUseCostEstimator']">
        <button
          type="button"
          class="btn btn-secondary-info2 btn-circle"
          (click)="onCostEstimator()"
          i18n-matTooltip
          matTooltip="Estimate the cost of your booking."
          matTooltipPosition="below"
          matTooltipClass="fit-tooltip"
        >
          <i class="cs-icon cs-icon-calculator"></i>
        </button>
      </li>
      <ng-container *ngxPermissionsOnly="['canSeeAIChat']">
        <li
          class="ml-2"
          *ngIf="aiResponderSub$ | async as aiResponderSub"
          matTooltip="To use AI Actions, just subscribe via the App Store. It’s free (no credits will be deducted)"
          matTooltipPosition="below"
          [matTooltipDisabled]="$safeNavigationMigration(aiResponderSub?.isValid)"
          i18n-matTooltip
        >
          <a
            class="btn btn-secondary-primary btn-circle"
            (click)="onAIChat($safeNavigationMigration(aiResponderSub?.isValid))"
            [style.filter]="aiResponderSub?.isValid ? 'grayscale(0)' : 'grayscale(1)'"
            i18n-matTooltip
            matTooltip="Let AI control whatever actions you want to perform. Click here to ask AI create your bookings, assign tasks, update rental and much more"
            matTooltipPosition="below"
            [matTooltipDisabled]="!aiResponderSub?.isValid"
          >
            <i class="cs-icon cs-icon-ai"></i>
          </a>
        </li>
      </ng-container>
      <ng-container *ngxPermissionsOnly="['canUseGlobalAdd']">
        <li class="ml-2" *ngIf="!(isFreePlan$ | async)">
          <app-global-plus-btn></app-global-plus-btn>
        </li>
      </ng-container>
    </ul>
  </div>
  <ul class="nav top-navbar border-bottom">
    <li *ngxPermissionsOnly="['canSeeDashboard']" routerLinkActive="active" class="nav-indigo">
      <a routerLink="/dashboard">
        <i class="cs-icon cs-icon-dashboard"></i>
        <span i18n>Dashboard</span>
      </a>
    </li>
    <!-- <li *ngxPermissionsOnly="['canSeeRates']" routerLinkActive="active" class="nav-green"> -->
    <!--   <a routerLink="/rates"> -->
    <!--     <i class="cs-icon cs-icon-dollar-circle"></i> -->
    <!--     <span>Rates</span> -->
    <!--   </a> -->
    <!-- </li> -->
    <li *ngxPermissionsOnly="['canSeeRentals']" routerLinkActive="active" class="nav-red">
      <a routerLink="/rentals">
        <i class="cs-icon cs-icon-buildings"></i>
        <span i18n>Rentals</span>
      </a>
    </li>
    <li *ngxPermissionsOnly="['canSeeChannels']" routerLinkActive="active" class="nav-blue">
      <a routerLink="/channels">
        <i class="cs-icon cs-icon-channels"></i>
        <span i18n>Channels</span>
      </a>
    </li>
    <li *ngxPermissionsOnly="['canSeeAutomations']" routerLinkActive="active" class="nav-green">
      <a routerLink="/automations">
        <i class="cs-icon cs-icon-automations"></i>
        <span i18n>Automations</span>
      </a>
    </li>
    <ng-container *ngxPermissionsOnly="['canSeeAddons']">
      <li
        class="nav-light-indigo"
        [class.active]="
          utility.isRouteActive('integrations') || utility.isRouteActive('websites') || utility.isRouteActive('widgets')
        "
      >
        <a (click)="isIntegrationsOpen = !isIntegrationsOpen" cdkOverlayOrigin #integrationsTrigger="cdkOverlayOrigin">
          <i class="cs-icon cs-icon-integrations"></i>
          <span i18n>Integrations</span>
        </a>
      </li>
      <ng-template
        cdkConnectedOverlay
        (overlayOutsideClick)="isIntegrationsOpen = false"
        [cdkConnectedOverlayPositions]="[{ originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' }]"
        [cdkConnectedOverlayOrigin]="integrationsTrigger"
        [cdkConnectedOverlayOpen]="isIntegrationsOpen"
        (attach)="dropdownOverlayAttached()"
        (detach)="dropdownOverlayDetached()"
      >
        <div class="bg-white shadow2 border rounded overflow-hidden" (delayClick)="isIntegrationsOpen = false">
          <ul class="dropdown-menu wide-dropdown-menu top-navbar-menu">
            <li class="text-uppercase text-light pt-0 pb-3 text-semi-bold border-bottom-0" i18n>Build a Website</li>
            <li class="text-uppercase text-light pt-0 pb-3 text-semi-bold border-bottom-0" i18n>
              Manage Your Revenue & Operations
            </li>
            <li
              *ngIf="canSee('webready')"
              [matTooltip]="isWebreadyInactiveTooltip$ | async"
              matTooltipPosition="above"
              [class.inactiveAddon]="isWebreadyInactive$ | async"
            >
              <a [href]="webreadyUrl()" target="_blank">
                <div class="icon-holder">
                  <img class="rategenie-icon" src="//cdn.tokeet.com/images/Appstore_logos/webready.svg" alt="" />
                </div>
                <div>
                  <h5 class="title" i18n>Webready</h5>
                  <p i18n>The best website builder for rentals</p>
                </div>
              </a>
            </li>
            <li
              *ngIf="canSee('rategenie')"
              [matTooltip]="isRateGenieInactiveTooltip$ | async"
              matTooltipPosition="above"
              [class.inactiveAddon]="isRateGenieInactive$ | async"
            >
              <a [href]="rategenieUrl()" target="_blank">
                <div class="icon-holder">
                  <img class="rategenie-icon" src="//cdn.tokeet.com/icons/rategenie_icon.png" alt="" />
                </div>
                <div>
                  <h5 class="title">Rategenie</h5>
                  <p i18n>The best rate optimization tool</p>
                </div>
              </a>
            </li>
            <li role="menuitem" *ngxPermissionsOnly="['canSeeWebsites']">
              <a class="" routerLink="/websites">
                <div class="icon-holder text-primary">
                  <i class="fal fa-globe"></i>
                </div>
                <div>
                  <h5 class="title" i18n>Websites</h5>
                  <p i18n>Free website builder</p>
                </div>
              </a>
            </li>
            <li
              role="menuitem"
              *ngIf="canSee('checklist')"
              [matTooltip]="isChecklistInactiveTooltip$ | async"
              matTooltipPosition="above"
              [class.inactiveAddon]="isChecklistInactive$ | async"
            >
              <a [href]="checklistUrl()" target="_blank">
                <div class="icon-holder">
                  <img src="//cdn.tokeet.com/images/Appstore_logos/checklist.svg" alt="" />
                </div>
                <div>
                  <h5 class="title">Checklist</h5>
                  <p i18n>Manage your property tasks and maintenance</p>
                </div>
              </a>
            </li>
            <li role="menuitem" *ngxPermissionsOnly="['canSeeWidgets']" class="border-bottom-0">
              <a class="" routerLink="/widgets">
                <div class="icon-holder text-primary">
                  <i class="fal fa-layer-plus"></i>
                </div>
                <div>
                  <h5 class="title" i18n>Widgets</h5>
                  <p i18n>Setup your AdvanceCM calendar, inquiry, and other widgets.</p>
                </div>
              </a>
            </li>
            <ng-container *ngIf="canSee('ownercenter')">
              <li *ngxPermissionsOnly="['canSeeOwnerCenter']" class="border-bottom-0">
                <a [href]="ownerCenterUrl()" target="_blank">
                  <div class="icon-holder">
                    <img src="/assets/images/icons/owners-icon.png" alt="" />
                  </div>
                  <div>
                    <h5 class="title">Owner Center</h5>
                    <p i18n>Manage invoices, statements, & owner relationship</p>
                  </div>
                </a>
              </li>
            </ng-container>
            <li class="text-uppercase text-light py-3 text-semi-bold border-bottom-0">Manage & Automate Workflow</li>
            <li class="text-uppercase text-light py-3 text-semi-bold border-bottom-0">Generated Reports</li>
            <li
              *ngIf="canSee('signature')"
              [matTooltip]="isSignatureInactiveTooltip$ | async"
              matTooltipPosition="above"
              [class.inactiveAddon]="isSignatureInactive$ | async"
            >
              <a [href]="signatureUrl()" target="_blank">
                <div class="icon-holder">
                  <img src="/assets/images/icons/signature-icon.png" alt="" />
                </div>
                <div>
                  <h5 class="title">Signature</h5>
                  <p i18n>Built-in eSignature tool</p>
                </div>
              </a>
            </li>
            <li
              *ngIf="canSee('power_reporting')"
              [matTooltip]="isPowerReportingInactiveTooltip$ | async"
              matTooltipPosition="above"
              [class.inactiveAddon]="isPowerReportingInactive$ | async"
            >
              <a [href]="powerReportingUrl()" target="_blank">
                <div class="icon-holder">
                  <img class="rategenie-icon" src="assets/integrations/rental-ninja-logo.svg" alt="" />
                </div>
                <div>
                  <h5 class="title">Power Reporting</h5>
                  <p i18n>Built-in reporting tool</p>
                </div>
              </a>
            </li>
            <li
              *ngIf="canSee('automata')"
              [matTooltip]="isAutomataInactiveTooltip$ | async"
              matTooltipPosition="above"
              [class.inactiveAddon]="isAutomataInactive$ | async"
              class="border-bottom-0"
            >
              <a [href]="automataUrl()" target="_blank">
                <div class="icon-holder">
                  <img class="automata-icon" src="//cdn.tokeet.com/icons/automata_icon.png" alt="" />
                </div>
                <div>
                  <h5 class="title">Automata</h5>
                  <p i18n>Create custom automated workflow</p>
                </div>
              </a>
            </li>
            <li *ngxPermissionsOnly="['canSeeReports']" class="border-bottom-0">
              <a [href]="reportsUrl()" target="_blank">
                <div class="icon-holder">
                  <img src="/assets/images/icons/margins-icon.png" alt="" />
                </div>
                <div>
                  <h5 class="title">Margins</h5>
                  <p i18n>The most advanced reporting application</p>
                </div>
              </a>
            </li>
            <li *ngxPermissionsOnly="['canSeeIntegrations']" class="full-width border-0 pb-0">
              <div routerLink="/integrations" class="btn btn-secondary-primary w-100">
                <i class="cs-icon cs-icon-right-down"></i> <ng-container i18n>More Integrations</ng-container>
              </div>
            </li>
          </ul>
        </div>
      </ng-template>
    </ng-container>

    <li *ngxPermissionsOnly="['canSeeAppStore']" routerLinkActive="active" class="nav-teal">
      <a
        [href]="appStoreUrl()"
        (click)="onVisitAppStore()"
        target="_blank"
        i18n-matTooltip
        matTooltip="Find & Subscribe to a variety of applications that enhance your experience & grow your business."
        matTooltipPosition="below"
      >
        <i class="cs-icon cs-icon-store"></i>
        <span i18n>App Store</span>
      </a>
    </li>

    <ng-container *ngxPermissionsOnly="['canSeeSettings']">
      <li
        class="nav-pink"
        [class.active]="
          utility.isRouteActive('settings') ||
          utility.isRouteActive('payments') ||
          utility.isRouteActive('sharing') ||
          utility.isRouteActive('templates') ||
          utility.isRouteActive('stealth') ||
          utility.isRouteActive('feeds')
        "
      >
        <a (click)="isSettingsOpen = !isSettingsOpen" cdkOverlayOrigin #settingsTrigger="cdkOverlayOrigin">
          <i class="cs-icon cs-icon-cog"></i>
          <span i18n>Settings</span>
        </a>
      </li>
      <ng-template
        cdkConnectedOverlay
        (overlayOutsideClick)="isSettingsOpen = false"
        [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'top' }]"
        [cdkConnectedOverlayOrigin]="settingsTrigger"
        [cdkConnectedOverlayOpen]="isSettingsOpen"
        (attach)="dropdownOverlayAttached()"
        (detach)="dropdownOverlayDetached()"
      >
        <div class="bg-white shadow2 border rounded overflow-hidden" (click)="isSettingsOpen = false">
          <ul class="dropdown-menu wide-dropdown-menu dropdown-menu-right top-navbar-menu">
            <ng-container *ngIf="aiResponderSub$ | async as aiResponderSub">
              <li *ngxPermissionsOnly="['canAISettings']">
                <a
                  href="javascript:;"
                  (click)="onAISettings(aiResponderSub.isValid)"
                  [ngStyle]="!aiResponderSub?.isValid ? { filter: 'grayscale(1)', opacity: '0.9' } : {}"
                  matTooltip="Please subscribe it before you can use this feature."
                  [matTooltipDisabled]="$safeNavigationMigration(aiResponderSub?.isValid)"
                  i18n-matTooltip
                >
                  <div class="icon-holder text-primary">
                    <svg-icon src="assets/images/icons/ai.svg" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                  </div>
                  <div>
                    <h5 class="title" i18n>AI Settings</h5>
                    <p i18n>Automatic bot response and feed data to the bot.</p>
                  </div>
                </a>
              </li>
            </ng-container>
            <li *ngxPermissionsOnly="['canSeeDataFeeds']">
              <a routerLink="/feeds">
                <div class="icon-holder text-info">
                  <svg-icon src="cloud-download" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                </div>
                <div>
                  <h5 class="title" i18n>Data Feeds</h5>
                  <p i18n>Extract data from AdvanceCM with a single, secure URL.</p>
                </div>
              </a>
            </li>
            <li>
              <a routerLink="/settings/branding">
                <div class="icon-holder text-indigo">
                  <svg-icon src="custom-theme" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                </div>
                <div>
                  <h5 class="title" i18n>Branding Info</h5>
                  <p i18n>Customize AdvanceCM to match your company look and feel.</p>
                </div>
              </a>
            </li>
            <li>
              <a routerLink="/settings/files">
                <div class="icon-holder text-primary">
                  <svg-icon src="folder" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                </div>
                <div>
                  <h5 class="title" i18n>File Cabinet</h5>
                  <p i18n>Upload and save files that every user may access.</p>
                </div>
              </a>
            </li>
            <li *ngxPermissionsOnly="['canSeePayments']">
              <a routerLink="/payments">
                <div class="icon-holder text-success">
                  <svg-icon src="card" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                </div>
                <div>
                  <h5 class="title" i18n>Payments</h5>
                  <p i18n>Allow users to pay you online and process credit cards.</p>
                </div>
              </a>
            </li>
            <li *ngIf="showCompliance">
              <a routerLink="/compliance">
                <div class="icon-holder text-success">
                  <svg-icon src="assets/images/icons/compliance.svg" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                </div>
                <div>
                  <h5 class="title" i18n>Compliance</h5>
                  <p i18n>Connect compliance APIs to ensure regulatory requirements are met.</p>
                </div>
              </a>
            </li>
            <li *ngxPermissionsOnly="['canSeeSharing']">
              <a routerLink="/sharing">
                <div class="icon-holder text-indigo">
                  <svg-icon src="calendar-share" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                </div>
                <div>
                  <h5 class="title" i18n>Shared Content</h5>
                  <p i18n>Share your calendars and other content via URL.</p>
                </div>
              </a>
            </li>
            <li>
              <a routerLink="/settings/email">
                <div class="icon-holder text-warning">
                  <svg-icon src="envelope" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                </div>
                <div>
                  <h5 class="title" i18n>Email Options</h5>
                  <p i18n>Configure automated email forwarding.</p>
                </div>
              </a>
            </li>
            <li *ngxPermissionsOnly="['canSeeMessagingSettings']">
              <a href="javascript:;" (click)="onMessagingSettings()">
                <div class="icon-holder text-warning">
                  <svg-icon src="envelope" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                </div>
                <div>
                  <h5 class="title" i18n>Message Settings</h5>
                  <p i18n>Configure sms, email and social media messaging settings.</p>
                </div>
              </a>
            </li>
            <li *ngxPermissionsOnly="['canSeeTemplates']">
              <a routerLink="/templates">
                <div class="icon-holder text-primary">
                  <svg-icon src="template" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                </div>
                <div>
                  <h5 class="title" i18n>Templates</h5>
                  <p i18n>Create message templates to automatically send to users and guests.</p>
                </div>
              </a>
            </li>
            <li *ngxPermissionsOnly="['canSeeStealth']">
              <a routerLink="/stealth">
                <div class="icon-holder text-danger">
                  <svg-icon src="stealth" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                </div>
                <div>
                  <h5 class="title" i18n>Stealth</h5>
                  <p i18n>Stealth mode unlists your Airbnb rental during specific hours of the day.</p>
                </div>
              </a>
            </li>
            <li>
              <a routerLink="/settings/user-settings">
                <div class="icon-holder text-info">
                  <svg-icon src="user-cog" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                </div>
                <div>
                  <h5 class="title" i18n>User Settings</h5>
                  <p i18n>Create and manage users, update their passwords, and set their user type.</p>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </ng-template>
    </ng-container>
  </ul>
</nav>
